module.exports = __webpack_public_path__ + "img/badge-most-appointment-bronze.3e776d54.png";